import {RsnSpinner} from '@raison/ui-kit';
import React, {FC} from 'react';

export interface RsnLoaderProps {
    color?: string;
    height?: string;
    width?: string;
    className?: string;
}

const RsnLoader: FC<RsnLoaderProps> = ({color = '#bdbdbd', height = '100%', width = '100%', className}) => {
    return (
        <div className={`${className ? className : ''}`}>
            <RsnSpinner customColor={color} h={height} w={width} />
        </div>
    );
};

export default RsnLoader;
